import { render } from "./orgIndex.vue?vue&type=template&id=a74f6758&scoped=true"
import script from "./orgIndex.vue?vue&type=script&lang=js"
export * from "./orgIndex.vue?vue&type=script&lang=js"

import "./orgIndex.vue?vue&type=style&index=0&id=a74f6758&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74f6758"]])

export default __exports__